import React from 'react';
import AdminLayoutWrapper from '../../components/layout/AdminLayoutWrapper';
import QuestionBank from '../teacher/QuestionBank';

const AdminQuestionBankPage = () => {
  return (
    <AdminLayoutWrapper>
      <QuestionBank 
        role="admin" 
        forceMine={false} 
        hideSelfOnlyToggle={true}
        showAllQuestions={true}
      />
    </AdminLayoutWrapper>
  );
};

export default AdminQuestionBankPage;
